import React from 'react';
import { createUseStyles } from 'react-jss';
import classnames from 'classnames';
const useStyles = createUseStyles({
    menuItem: {
        display: 'flex',
        gap: 8,
        color: '#222239',
        fontSize: 14,
        whiteSpace: 'nowrap',
        padding: 8,
        paddingRight: 16,
        '&:hover': { backgroundColor: '#EAEDF5' },
    },
    clickable: { cursor: 'pointer' },
});
function MenuList({ children, onClick, }) {
    const classes = useStyles();
    return (React.createElement("li", null,
        React.createElement("div", { className: classnames(classes.menuItem, onClick && classes.clickable), role: "button", tabIndex: 0, onKeyDown: () => onClick && onClick(), onClick: () => onClick && onClick() }, children)));
}
export default MenuList;
//# sourceMappingURL=MenuItem.js.map